import React, {Component, ReactNode} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {
    HeadingAreaMessageComponent,
    HeadingAreaMessageParams,
} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {FACILITY_RESERVATION_CLASSIFICATION, MESSAGE_TYPE, PERSONAL_INFO_OPERATION_TYPE} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import {PageFooterArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import NatFacilityReserveRepo from '../facilityReserve/repository/NatFacilityReserveRepo'
import {ClosedPeriod, NatPostClosedSettingParams, ReservationsByClosedPeriod} from './repository/NatPostClosedSetting'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AsyncCommunicationProps} from '../../../components/shared/hoc/withAsyncCommunication'
import {
    Box,
    DialogActions,
    DialogContent,
    DialogTitle,
    ThemeProvider,
    Theme,
    StyledEngineProvider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    createTheme,
} from '@mui/material';
import {
    FlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RightRowFlexContainer,
    RowFlexContainer,
} from '../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {Colors, FontSizeInPixel, FontWeights} from '../../../styledComponents/Constants'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {AdminDefaultButton, AdminSecondaryButton} from '../../../styledComponents/adminPage/Buttons'
import {Moment} from 'moment'
import {createIconWithLevel} from '../../../styledComponents/adminPage/IconCreator'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import {getStringOrEmptyString} from '../../common/util/Natutil'
import {PersonalInfoExtractHistoryRepo} from '../../../components/PersonalInfoExtractHistoryRepo'


// TODO: @mui/styles用 styled-componentsを使用するため削除してDefaultThemeはstyled-componentsの物を使用する
//  declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }


interface Props {
    facilityReserveRepo: NatFacilityReserveRepo,
    personalInfoExtractHistoryRepo: PersonalInfoExtractHistoryRepo,
    currentDateTime: Moment,
    closedPeriods: ClosedPeriod[],
    closedSettingParam: NatPostClosedSettingParams,
    eventEmitter: EventEmitterExAdmin,
    onCancelReservationClick: () => void,
    onCloseButtonClick: () => void,
    onDownloadClick: (closedPeriods: ClosedPeriod[]) => void,
}

interface State {
    checkedDescription: boolean
    clickedDownloadButton: boolean
    headingAreaMessageParams: Nullable<HeadingAreaMessageParams>
    errorHeadingAreaMessageParams: Nullable<HeadingAreaMessageParams>
}

export default class CancelReservationsForm extends Component <Props & AsyncCommunicationProps, State> {
    constructor(props: Readonly<Props & AsyncCommunicationProps>) {
        super(props)

        const params: HeadingAreaMessageParams = {
            messageLevel: MESSAGE_TYPE.INFORMATION,
            title: null,
            detail: Messages.IOPCC0007.toString('休館設定'),
        }

        this.state = {
            checkedDescription: false,
            clickedDownloadButton: false,
            headingAreaMessageParams: params,
            errorHeadingAreaMessageParams: null,
        }
        this.handleDownloadDescriptionCharge = this.handleDownloadDescriptionCharge.bind(this)
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this)
        this.handleDownloadButtonClick = this.handleDownloadButtonClick.bind(this)
        this.handleOkClickForCancelReservations = this.handleOkClickForCancelReservations.bind(this)
    }

    handleDownloadDescriptionCharge(label: string, checked: boolean): void {
        this.setState({checkedDescription: checked})
    }

    handleCloseButtonClick(): void {
        this.props.onCloseButtonClick()
    }

    async handleDownloadButtonClick(): Promise<void> {
        const {closedPeriods, personalInfoExtractHistoryRepo} = this.props
        const countUserNames = this.countUserNamesFromReservationList(closedPeriods)
        if (countUserNames > 0) {
            await this.props.asyncCallFunction(
                personalInfoExtractHistoryRepo.registerPersonalInfoExtractHistory.bind(
                    personalInfoExtractHistoryRepo,
                    PERSONAL_INFO_OPERATION_TYPE.EXPORT.value,
                    countUserNames,
                    'キャンセルリスト',
                ), (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
        }

        this.props.onDownloadClick(this.props.closedPeriods)
        this.setState({clickedDownloadButton: true})
    }

    countUserNamesFromReservationList(closedPeriods: ClosedPeriod[]): number {
        let countUserNames: number = 0
        closedPeriods.flatMap(closedPeriod => {
            closedPeriod.reservationList.forEach(reservation => {
                if ((reservation.userFamilyName !== null) || (reservation.userFirstName !== null)) {
                    countUserNames = countUserNames + 1
                }
            })
        })
        return countUserNames
    }

    renderClosedSetting(closedPeriod: ClosedPeriod): ReactNode {
        return (<>
            <AlignItemsStartFlexContainer>
                <ClosedSettingTag>施設</ClosedSettingTag>
                <FacilityNameDiv>
                    {closedPeriod.facilityName}
                </FacilityNameDiv>
                <ClosedSettingTag>休館期間</ClosedSettingTag>
                <ClosedPeriodDiv>
                    {closedPeriod.startDateTime.format('YYYY/MM/DD HH:mm')}
                    〜
                    {closedPeriod.endDateTime.format('YYYY/MM/DD HH:mm')}
                </ClosedPeriodDiv>
                <BlockSpacer height={'10px'}/>
            </AlignItemsStartFlexContainer>
        </>)
    }

    async handleOkClickForCancelReservations(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.props.eventEmitter.closeDialog()
        try {
            // 休館設定一括反映
            let returnValue: Nullable<boolean>
            returnValue = await this.props.asyncCallFunction(
                this.props.facilityReserveRepo.cancelReservations.bind(
                    this.props.facilityReserveRepo,
                    this.props.closedSettingParam,
                ),
                async (httpErrorOrNetworkError) => {
                    if (httpErrorOrNetworkError.responseBody.requestError !== null) {
                        const message = httpErrorOrNetworkError.responseBody.requestError.message
                        const headingAreaMessageParams: HeadingAreaMessageParams = {
                            messageLevel: MESSAGE_TYPE.ERROR,
                            title: null,
                            detail: message,
                        }
                        this.setState({
                            errorHeadingAreaMessageParams: headingAreaMessageParams,
                        })
                    }
                },
            )
            if (returnValue !== null && returnValue) {
                this.props.onCancelReservationClick()
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderReservationListHeader(hasPastReservation: boolean): ReactNode {
        return (
            <StyledTableHead>
                <TableRow>
                    <StyledTableRigeNameCell>
                        棟名
                    </StyledTableRigeNameCell>
                    <StyledTableRoomNumberCell>
                        部屋番号
                    </StyledTableRoomNumberCell>
                    <StyledTableUserNameCell>
                        利用者名
                    </StyledTableUserNameCell>
                    <StyledTableCell>
                    </StyledTableCell>
                    <StyledTablePeriodCell>
                        <LeftRowFlexContainer>
                            <div>予約日時</div>
                            {
                                hasPastReservation &&
                                <Box ml={'8px'}><AnnotationBlock>※過去の予約が含まれています</AnnotationBlock></Box>
                            }
                        </LeftRowFlexContainer>
                    </StyledTablePeriodCell>
                </TableRow>
            </StyledTableHead>
        )
    }

    renderReservation(reservation: ReservationsByClosedPeriod): ReactNode {
        let userRidgeName = reservation.userRidgeName === null ? '' : reservation.userRidgeName
        let userRoomNumber = reservation.userRoomNumber === null ? '' : reservation.userRoomNumber
        if (reservation.facilityReserveCategory === FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) {
            userRidgeName = '-'
            userRoomNumber = '-'
        }
        let userName = `${getStringOrEmptyString(reservation.userFamilyName)} ${getStringOrEmptyString(reservation.userFirstName)}`
        if (userName.trim() === '') {
            userName = ''
        }
        const isPastReservation: boolean = reservation.startDateTime.isBefore(this.props.currentDateTime)

        return (<>
            <StyledTableCell>
                {userRidgeName}
            </StyledTableCell>
            <StyledTableCell>
                {userRoomNumber}
            </StyledTableCell>
            <StyledTableUserNameCell>
                {userName}
            </StyledTableUserNameCell>
            <RightTableCell>
                <AnnotationBlock>{isPastReservation ? '※' : '\u2003'}</AnnotationBlock>
            </RightTableCell>
            <StyledTableCell>
                {reservation.startDateTime.format('YYYY/MM/DD HH:mm')}
                〜
                {reservation.endDateTime.format('YYYY/MM/DD HH:mm')}
            </StyledTableCell>
        </>)
    }

    renderReservationList(closedPeriod: ClosedPeriod): ReactNode {
        const reservationList: ReservationsByClosedPeriod[] = closedPeriod.reservationList
        const hasPastReservation: boolean = reservationList.some(reservation => {
            return reservation.startDateTime.isBefore(this.props.currentDateTime)
        })

        return (<>
            <CancelTable>
                {this.renderReservationListHeader(hasPastReservation)}
                <TableBody>
                    {
                        reservationList.map((reservation, index) => (
                                <TableRow key={`${reservation.facilityReserveId}-${index}`}>
                                    {this.renderReservation(reservation)}
                                </TableRow>
                            ),
                        )
                    }
                </TableBody>
            </CancelTable>
        </>)
    }

    renderReservations(): ReactNode {
        const {closedPeriods} = this.props
        const closedPeriodList = closedPeriods.filter(closedPeriod => closedPeriod.reservationList.length > 0)
        return (<Box>
            {
                closedPeriodList.map((closedPeriod, index) => (
                        <Box key={index}>
                            {index > 0 && <BolderSpacer/>}
                            {this.renderClosedSetting(closedPeriod)}
                            {this.renderReservationList(closedPeriod)}
                        </Box>
                    ),
                )
            }
        </Box>)
    }

    render(): ReactNode {
        const {
            headingAreaMessageParams, errorHeadingAreaMessageParams, clickedDownloadButton, checkedDescription,
        } = this.state
        return <>
            <DialogTitle id="cancelReservations-dialog-title">
                {
                    (headingAreaMessageParams && !errorHeadingAreaMessageParams) &&
                    <HeadingAreaMessageComponent params={headingAreaMessageParams}/>
                }
                {
                    (errorHeadingAreaMessageParams) &&
                    <HeadingAreaMessageComponent params={errorHeadingAreaMessageParams}/>
                }
                <LeftRowFlexContainer>
                    {createIconWithLevel(MESSAGE_TYPE.WARNING)}予約の確認
                </LeftRowFlexContainer>
            </DialogTitle>
            <Box ml={'24px'}>登録した休館期間には、既に以下の予約が登録されています。</Box>
            <ReservationDialogContent>
                {this.renderReservations()}
            </ReservationDialogContent>
            <RightRowFlexContainer>
                <Box mt={'12px'} mr={'24px'}>
                    <CancelReservationDefaultButton onClick={this.handleDownloadButtonClick}>
                        予約一覧をダウンロード
                    </CancelReservationDefaultButton>
                </Box>
            </RightRowFlexContainer>
            <StyledCheckBoxContainer>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <PPCheckboxGroup
                            data={[{
                                label: 'キャンセルした予約は元に戻せないことを了承した上で、予約をキャンセルします。',
                                checked: checkedDescription,
                            }]}
                            onChangeChecked={this.handleDownloadDescriptionCharge}
                        />
                    </ThemeProvider>
                </StyledEngineProvider>
            </StyledCheckBoxContainer>
            <DialogActions>
                <StyledPageFooterArea>
                    <PageFooterAreaLeft>
                        <MarginFlexContainer>
                            <CancelReservationDefaultButton onClick={this.handleCloseButtonClick}>
                                予約をキャンセルせずに終了
                            </CancelReservationDefaultButton>
                        </MarginFlexContainer>
                    </PageFooterAreaLeft>
                    <PageFooterAreaRight>
                        <LeftColumnFlexContainer>
                            <div>
                                キャンセルする場合は、予約一覧のダウンロードが必須です。
                            </div>
                            <ReserveCancelButton
                                onClick={this.handleOkClickForCancelReservations}
                                disabled={!(checkedDescription && clickedDownloadButton)}>
                                すべての予約をキャンセルする
                            </ReserveCancelButton>
                        </LeftColumnFlexContainer>
                    </PageFooterAreaRight>
                </StyledPageFooterArea>
            </DialogActions>
        </>;
    }
}

const ReservationDialogContent = styled(DialogContent)`
  border: 1px solid #dadde9;
  margin: 10px;
  padding: 12px!important;
  height: 383px;
`
const BolderSpacer = styled(Box)`
  border-top: 1px solid #dadde9;
  margin: 16px 0;
`
const ClosedSettingTag = styled.div`
  color: ${Colors.Body};
  background-color: ${Colors.Background};
  font-size: ${FontSizeInPixel.Small};
  font-weight: ${FontWeights.Light};
  line-height: 12px;
  padding: 3px 10px 3px 10px;
`
const FacilityNameDiv = styled.div`
  color: ${Colors.Body};
  font-size: ${FontSizeInPixel.Small};
  font-weight: ${FontWeights.Bold};
  line-height: 12px;
  padding: 3px 10px 3px 10px;
  width: 40%;
  word-break: break-all;
`
const ClosedPeriodDiv = styled.div`
  color: ${Colors.Body};
  font-size: ${FontSizeInPixel.Small};
  font-weight: ${FontWeights.Bold};
  line-height: 12px;
  padding: 3px 10px 3px 10px;
  width: 40%;
`

// @ts-ignore
const StyledCheckBoxContainer = styled(FlexContainer)`
  justify-content: center;
  background-color: #fce9c8;
  margin: 15px 24px 0 24px;
  padding: 10px 0;
`
const StyledTableHead = styled(TableHead)`
  &.MuiTableHead-root {
    background-color: ${Colors.Background};
  }
`
const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding: 5px 5px 5px 5px;
    border: none;
    width: 10%;
    word-break: break-all;
  }
`
const StyledTableRigeNameCell = styled(StyledTableCell)`
  &.MuiTableCell-root {
    width: 15%;
  }
`
const StyledTableRoomNumberCell = styled(StyledTableCell)`
  &.MuiTableCell-root {
    width: 10%;
  }
`
const StyledTableUserNameCell = styled(StyledTableCell)`
  &.MuiTableCell-root {
    width: 25%;
  }
`
const StyledTablePeriodCell = styled(StyledTableCell)`
  &.MuiTableCell-root {
    width: 50%;
  }
`
const RightTableCell = styled(StyledTableCell)`
  &.MuiTableCell-root {
    padding: 5px 0 5px 5px;
    text-align: right;
  }
`
const StyledPageFooterArea = styled(PageFooterArea)`
  margin: 15px 24px 16px 24px;
  padding: 0;
  align-items: flex-end;
`
const PageFooterAreaLeft = styled(RowFlexContainer)`
  justify-content: flex-end;
  flex-grow: 1;
  order: 1;
`
const PageFooterAreaRight = styled(RowFlexContainer)`
  justify-content: flex-start;
  flex-grow: 1;
  order: 2;
`
const MarginFlexContainer = styled(FlexContainer)`
  margin: 0 40px 0 140px;
`
const AnnotationBlock = styled.div`
  color: #f44336;
`
const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
  align-items: flex-start;
`
const CancelReservationDefaultButton = styled(AdminDefaultButton)`
 &.MuiButton-root {
  width: 315px;
 }
`
const ReserveCancelButton = styled(AdminSecondaryButton)`
 &.MuiButton-root {
  width: 315px;
  background-color: #D7374A;
  color: #FFFFFF;
  box-shadow: 0px 2px 0px #88222E;
  border-radius: 8px;
  font-size: ${FontSizeInPixel.Small};
  font-weight: ${FontWeights.Bold};
 }
 &.Mui-disabled {
   background-color: rgba(0,0,0,0.12);
   color: rgba(0,0,0,0.26);
   box-shadow: none;
 }
`
const CancelTable = styled(Table)`
  margin-top: 5px;
  table-layout: fixed;
`
const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem!important',
                },
            },
        },
    },
})
